import { graphClient } from '../../graph-client'
import { GET_GIFT_FIRST, GET_GIFTS } from './gql'
import type { GetFirst, GetList } from './types'

class GiftService {
  async getFirst(params: GetFirst.Input) {
    const request = await graphClient.request<GetFirst.Output>(
      GET_GIFT_FIRST,
      params,
    )

    return request?.getGiftFirst
  }

  async getList({ take = 20, skip = 0, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(GET_GIFTS, {
      ...params,
      take: take,
      skip: take * skip,
    })

    return request?.getGifts
  }
}

export const giftService = new GiftService()
